export enum ChatType {
    DirectMessage = "DirectMessage",
    Group = "Group",
    System = "System",
    TaskSupport = "TaskSupport", // Добавляем новый тип чата
}

export enum ChatScope {
    General = "General",
    Task = "Task",
    TaskDraft = "TaskDraft",
    Organization = "Organization",
    Support = "Support",
    Announcements = "Announcements",
    ManagerToUser = "ManagerToUser", // Добавляем новую область видимости
    UserToManager = "UserToManager",
    ManagerToManager = "ManagerToManager",
}

export enum ParticipantRole {
    ReadOnly = "ReadOnly",
    Member = "Member",
    Moderator = "Moderator",
    Admin = "Admin",
    Owner = "Owner",
}

export enum ChatMessageType {
    Text = "Text",
    // Добавьте другие типы сообщений, если они есть на бэкенде
}
